/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagPostureWorkloadCloudSummary {
    getFixupPrototypeFunction() { return TagPostureWorkloadCloudSummary.fixupPrototype; }

    static newInstance(model: Partial<TagPostureWorkloadCloudSummary>): TagPostureWorkloadCloudSummary {
        let obj = Object.assign(new TagPostureWorkloadCloudSummary(), model);
        TagPostureWorkloadCloudSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagPostureWorkloadCloudSummary>): TagPostureWorkloadCloudSummary {
        if (!model) return null;
        return TagPostureWorkloadCloudSummary.newInstance(<TagPostureWorkloadCloudSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagPostureWorkloadCloudSummary) {
        if (!obj) return;

        models.TagPostureWorkloadCloudSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagPostureWorkloadCloudSummary): boolean {
        Object.setPrototypeOf(obj, TagPostureWorkloadCloudSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.workload_cloud_summary) {
            for (let val of this.workload_cloud_summary) {
                models.TagPostureCloudAccountSummary.fixupPrototype(val);
            }
        }
    }

    /**
     * Workload id
     */
    workload_id: string;

    /**
     * Workload Cloud Tag Posture Summary
     */
    workload_cloud_summary: Array<models.TagPostureCloudAccountSummary>;

}
